import { useCallback, useRef } from 'react';
import { KeyCode } from '../../../keycode';
import { filterOptions } from './filter-options';
import debounce from '../../../debounce';
export var isChar = function (keyCode) {
    return [0, KeyCode.enter, KeyCode.space, KeyCode.tab].indexOf(keyCode) === -1;
};
export var isRepeatedChar = function (str) {
    var repeatedChar = Array.prototype.reduce.call(str, function (a, b) {
        return a === b ? b : null;
    }, str[0]);
    return Boolean(repeatedChar);
};
export var useNativeSearch = function (_a) {
    var options = _a.options, isKeyboard = _a.isKeyboard, highlightOption = _a.highlightOption, highlightedOption = _a.highlightedOption, isInteractive = _a.isInteractive;
    var value = useRef('');
    var delayedResetValue = useCallback(debounce(function () {
        value.current = '';
    }, 500), [debounce, value]);
    var filter = useCallback(function (searchText) {
        return filterOptions(options, searchText).filter(function (option) { return option.type !== 'parent' && isInteractive(option); });
    }, [filterOptions, options, isInteractive]);
    var handleNewValue = useCallback(function (newValue) {
        var matchingOptions = filter(newValue);
        if (matchingOptions.length === 1) {
            highlightOption(matchingOptions[0]);
            return;
        }
        // Hit the same char over and over, we assume they want to cycle through
        if (newValue.length > 1 && isRepeatedChar(newValue)) {
            var matchingOptions_1 = filter(newValue[0]);
            if (matchingOptions_1.length > 0) {
                var active = matchingOptions_1
                    .map(function (_a) {
                    var option = _a.option;
                    return option.value;
                })
                    .indexOf(highlightedOption.value);
                // Pick the next thing (if something with this prefix wasn't selected
                // we'll end up with the first option)
                active += 1;
                active = active % matchingOptions_1.length;
                highlightOption(matchingOptions_1[active]);
                return;
            }
        }
        // We have multiple things that start with this prefix.  Based on the
        // behavior of native select, this is considered after the repeated case
        if (matchingOptions.length > 0) {
            highlightOption(matchingOptions[0]);
        }
    }, [filter, highlightOption, isRepeatedChar, highlightedOption, highlightOption]);
    return useCallback(function (e) {
        isKeyboard.current = true;
        var charCode = e.charCode;
        if (!isChar(charCode)) {
            return;
        }
        delayedResetValue();
        var newValue = value.current + String.fromCharCode(charCode);
        value.current = newValue;
        handleNewValue(newValue);
    }, [isKeyboard, isChar, delayedResetValue, handleNewValue]);
};
//# sourceMappingURL=use-native-search.js.map